export enum Currency {
  MDL = 'MDL',
  EUR = 'EUR',
  USD = 'USD',
  KZT = 'KZT',
  PLN = 'PLN',
}
